module.exports = __webpack_public_path__ + "img/big-logo.75d30b39.svg";